import * as React from 'react';

import { useAtom } from 'jotai';

import {
  DisableInviteConfirmation,
  ResetInviteConfirmation,
} from '~teacher/components/workspaces/InviteWorkspaceDialog/confirmations';

import { assertUnreachable } from '../../../../util/assertUnreachable';
import { workspaceInviteDialogAtom } from './atoms/atoms';
import { InvitesDialog } from './InvitesDialog';

interface WorkspaceInviteDialogProps {
  workspaceId: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function WorkspaceInviteDialog({
  workspaceId,
  open,
  setOpen,
}: WorkspaceInviteDialogProps) {
  const [{ currentView }, dispatch] = useAtom(workspaceInviteDialogAtom);

  const handleClose = () => {
    setOpen(false);
    dispatch({ type: 'Close' });
  };

  switch (currentView) {
    case 'ActionOverlayResetLink': {
      return (
        <ResetInviteConfirmation
          handleClose={handleClose}
          isOpen={open}
          workspaceId={workspaceId}
        />
      );
    }
    case 'ActionOverlayDisableLink': {
      return (
        <DisableInviteConfirmation
          handleClose={handleClose}
          isOpen={open}
          workspaceId={workspaceId}
        />
      );
    }
    case 'InviteLinksView': {
      return (
        <InvitesDialog
          isOpen={open}
          handleClose={handleClose}
          workspaceId={workspaceId}
        />
      );
    }
    default: {
      assertUnreachable(currentView);
    }
  }
}
